import tippy from "tippy.js";

export default class AxTooltip {
    // TODO custom arrow?
    // TODO allow for click trigger?
    // TODO inlinePositioning prop?
    // TODO interactive prop?
    // TODO touch?
    // TODO data attributes to control options?


    private static defaultProps: object = {
        theme: "axiomTooltip",
        arrow: true,
        delay: [1200, 200],
        maxWidth: 160,
        placement: 'bottom',
        trigger: 'mouseenter focus',
        offset: [0, 8],
        allowHTML: false,
        role: 'tooltip',
        content: (reference: any) => reference.getAttribute('title'),
        // popperOptions - can be finely adjusted later if requirements change
    }

    // init on specific element
    public static init(item: HTMLElement, placement?: string) {
        // TODO extend to accept additional init props
        if (placement) {
            Object.assign(this.defaultProps, { placement: placement});
        }
        tippy(item, AxTooltip.defaultProps);
        item.removeAttribute("title");
        item.classList.add('ax-has-tooltip');
    }

    // update content
    public static setContent(item: HTMLElement, value: string) {
        (item as any)._tippy.setContent(value);
        setTimeout(() => {
            // In a setTimeout to make sure DOM is ready
            item.removeAttribute("title");
        }, 0);
    }

    // set single prop
    public static setProp(item: HTMLElement, prop: string, value: string | number[] | number) {
        (item as any)._tippy.setProps({
            [prop]: value
        });
    }

    // set multiple props
    public static setProps(item: HTMLElement, props: object, value: any) {
        (item as any)._tippy.setProps(props);
    }

    // Wrapped Tippy methods
    public static destroy(item: HTMLElement) {
        (item as any)._tippy.destroy();
    }

    public static disable(item: HTMLElement) {
        (item as any)._tippy.disable();
    }

    public static enable(item: HTMLElement) {
        (item as any)._tippy.enable();
    }

    public static show(item: HTMLElement) {
        (item as any)._tippy.show();
    }

    public static hide(item: HTMLElement) {
        (item as any)._tippy.hide();
    }
}
